import { createApp } from 'vue'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/league-spartan/600.css'
import '@fontsource/league-spartan/700.css'
import '@fontsource/league-spartan/800.css'
import './styles/tokens.css'
import './styles/global.scss'
import { createAppearanceController } from './theme/appearance'
import App from './App.vue'
import router from './router'
import { store } from './store'

createAppearanceController()
createApp(App).use(store).use(router).mount('#app')
